import React, { Component, useContext } from "react";
import Logo from "./logo";
import HelpButton from "./help-button";
import StartOverButton from "./start-over-button";
import Dropdown from "./dropdown-field";
import LocationInput from "./location-input";
import GettingStartedContext from "../utils/GettingStartedContext";

const SkipHeroSection = () => {
    const {
        data,
        setData,
        setShowResult,
        setShowSkip,
        getProperty,
        setLocation,
        langString,
        lang,
        scrollTo,
        showSkip,
        result,
        plane,
        plan,
        setPlan,
        ownership,
        hours,
        setHours,
        getLink,
        setSubmittedQuestions,
        showFooter,
        showToolTip,
    } = useContext(GettingStartedContext);

    const loadResults = () => {
        setSubmittedQuestions([]);

        if (ownership && plan && plane) {
            fetch(getLink("getManualResults"), {
                method: "POST",
                body: JSON.stringify({
                    data: {
                        plane: plane,
                        ownership: ownership,
                        plan: plan.ID,
                        hours: hours,
                        location: location,
                    },
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    if (!json.BestPlane) {
                        json.BestPlane = json.Plane;
                    }
                    if (!json.BestOwnership) {
                        json.BestOwnership = json.Ownership;
                    }

                    const options = {
                        ...data.Options,
                        ...json,
                    };

                    setData({
                        ...data,
                        Options: options,
                    });
                    setPlan(json.Plan);
                    setHours(json.Plan.ID);
                    setShowResult(true);
                    setShowSkip(false);
                    showFooter();
                });
        }
    };

    return (
        <>
            <div>
                <div className="gsa__results-skip">
                    <div
                        className="gsa__bg"
                        style={{
                            backgroundImage:
                                "url(" +
                                (data.ResultPageImageURL
                                    ? data.ResultPageImageURL
                                    : data.ImageURL) +
                                ")",
                        }}
                    />
                    <div className="gsa__content">
                        <div className="gsa__header">
                            <div className="grid-container">
                                <div className="grid-x">
                                    <div className="cell col-6">
                                        <Logo
                                            url={data.BaseURL}
                                            locale={lang}
                                        />
                                    </div>
                                    <div className="cell col-6 gsa__header-buttons">
                                        <ul>
                                            <HelpButton />
                                            <StartOverButton
                                                text={data.ExitText}
                                                startOver={false}
                                                exit={true}
                                            />
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="gsa__form">
                            <div className="grid-container">
                                <h4 className="gsa__form__step">
                                    {langString("SKIPPED_PAGE_TITLE")}
                                </h4>
                                <h2 className="gsa__form__question">
                                    {langString("SKIPPED_PAGE_NOTE")}
                                </h2>
                                <div className="gsa__form__skip-inputs">
                                    <ul>
                                        <li>
                                            <label>
                                                {langString("CHOOSE_YOUR_JET")}
                                                {showToolTip(
                                                    "CHOOSE_YOUR_JET_TOOLTIP"
                                                )}
                                            </label>
                                            <Dropdown
                                                type="Planes"
                                                defaultOption={0}
                                                defaultTitle={langString(
                                                    "CHOOSE_YOUR_JET_HOLDER"
                                                )}
                                            />
                                        </li>
                                        <li>
                                            <label>
                                                {langString(
                                                    "CHOOSE_YOUR_OWNERSHIP"
                                                )}
                                                {showToolTip(
                                                    "CHOOSE_YOUR_OWNERSHIP_TOOLTIP"
                                                )}
                                            </label>
                                            <Dropdown
                                                type="Ownerships"
                                                defaultOption={0}
                                                result={result}
                                                defaultTitle={langString(
                                                    "CHOOSE_YOUR_OWNERSHIP_HOLDER"
                                                )}
                                            />
                                        </li>
                                        <li>
                                            <label>
                                                {langString(
                                                    "CHOOSE_YOUR_HOURS"
                                                )}
                                                {showToolTip(
                                                    "CHOOSE_YOUR_HOURS_TOOLTIP"
                                                )}
                                            </label>
                                            <Dropdown
                                                type="Plans"
                                                defaultOption={0}
                                                result={result}
                                                defaultTitle={langString(
                                                    "CHOOSE_YOUR_HOURS_HOLDER"
                                                )}
                                            />
                                        </li>
                                        <li>
                                            <label>
                                                {langString(
                                                    "YOU_TYPICALLY_DEPART_FROM"
                                                )}
                                                {showToolTip(
                                                    "YOU_TYPICALLY_DEPART_FROM_TOOLTIP"
                                                )}
                                            </label>
                                            <LocationInput
                                                setCurrentOption={(v) => {
                                                    setLocation(v);
                                                }}
                                                placeHolder={langString(
                                                    "YOU_TYPICALLY_DEPART_FROM_HOLDER"
                                                )}
                                            />
                                        </li>
                                        <li className="actions">
                                            <button
                                                className="gsa__form-button button secondary"
                                                onClick={() => loadResults()}
                                            >
                                                <span>
                                                    {langString("VIEW_RESULTS")}
                                                    <svg
                                                        id="Group_357"
                                                        data-name="Group 357"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="7.1"
                                                        height="12.974"
                                                        viewBox="0 0 7.1 12.974"
                                                    >
                                                        <path
                                                            id="chevron-thin-up"
                                                            d="M5.488,6.429.15.883a.521.521,0,0,1,0-.732.508.508,0,0,1,.724,0L6.726,6.062a.521.521,0,0,1,0,.732L.874,12.7a.508.508,0,0,1-.724,0,.521.521,0,0,1,0-.732L5.488,6.429Z"
                                                            transform="translate(0.224 0) rotate(1)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SkipHeroSection;
